export const getApiUrl = () =>
  window.location.hostname.includes('vireo-renovation.fr')
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
